import { render, staticRenderFns } from "./nurseData.vue?vue&type=template&id=7485dc1c&scoped=true&"
import script from "./nurseData.vue?vue&type=script&lang=js&"
export * from "./nurseData.vue?vue&type=script&lang=js&"
import style0 from "./nurseData.vue?vue&type=style&index=0&id=7485dc1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7485dc1c",
  null
  
)

export default component.exports